module.exports = __webpack_public_path__ + "static/media/fun.4f109d24.webp";